import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgZincSoapBarGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M39.985 15.631c-.1-1.047-.497-1.998-1.291-2.665-.795-.666-1.788-1.047-2.881-.951-.993.095-1.987.475-2.682 1.142H11.477C9.589 13.157 8 14.68 8 16.488v16.18C8 34.479 9.59 36 11.477 36H33.13c1.887 0 3.477-1.523 3.477-3.331v-13.04c.894-.095 1.688-.571 2.384-1.237.695-.762 1.092-1.714.993-2.76ZM33.13 34.858H11.477c-1.292 0-2.285-.952-2.285-2.19v-16.18c0-1.237.993-2.19 2.285-2.19h20.86c-.2.572-.398 1.048-.299 1.714.1 1.808 1.59 3.331 3.378 3.617v13.04c0 1.237-1.093 2.189-2.285 2.189Zm4.867-17.228a2.49 2.49 0 0 1-1.887.857c-1.49.095-2.781-1.047-2.88-2.475 0-.666.198-1.428.695-1.904a2.49 2.49 0 0 1 1.887-.856h.1c.695 0 1.29.285 1.887.666.596.476.894 1.142.894 1.809.099.666-.2 1.427-.696 1.903Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M27.767 18.296c-1.987 0-3.675 1.523-3.675 3.522 0 1.999 1.59 3.522 3.675 3.522 2.086 0 3.675-1.523 3.675-3.522 0-1.999-1.688-3.522-3.675-3.522Zm0 5.806c-1.291 0-2.384-1.047-2.384-2.284 0-1.237 1.093-2.284 2.384-2.284s2.384 1.047 2.384 2.284c0 1.237-.993 2.284-2.384 2.284Z",
    fill: "currentColor"
  }));
}

export { SvgZincSoapBarGlyph as default };
